let env;

if (process.env.NODE_ENV === "production") {
  env = require("./environment.prod.jsx");
} else {
  env = require("./environment.jsx");
}

export const base_path = env.base_path;
export const image_path = env.image_path;
